import "./_title-2-columns-cards-styles.scss";

import './title-2-columns-cards';
